import axios from 'axios';
import { VehicleBatchModel } from '../Models/VehicleBatchModel';

const updateVehicleBatch = (batch: VehicleBatchModel) => axios.patch(`classifications/${batch.classificationsId[0]}/vehicles/update-batch`, batch);

export default { 
    updateVehicleBatch
};